import apiBackends from './api-backends.json';
export const environment = {
  name: 'Test',
  apiV2: `${apiBackends.Test}/api/v2`,
  token: `${apiBackends.Test}/token`,
  dhHogiaIdRootUrl: 'https://dhhogiaidtest.hogia.se/',
  production: false,
  hasEInvoiceB2CEnabled: false,
  trialTracking: undefined as TrialTrackingConfig | undefined,
  // Global search formatting toggles (test default: raw API to compare)
  globalSearchEnableExperimental: false,
  globalSearchFormatMode: 'api-raw',
};
import { TrialTrackingConfig } from './trial-tracking-config';
